module.exports = __webpack_public_path__ + "static/licensing-lg-02ae5122ca805c5e92a84559cd90e507.jpg";